import axios from "axios";
import { API_URL } from "./conection";

export const getProfiles = async () => {
  try {
    const res = await axios.get(`${API_URL}/profiles`);
    return res.data;
  } catch (error) {
    console.error("Error en getProfiles:", error);
    return [];
  }
};

export const createProfile = async (profile) => {
  const res = await axios.post(`${API_URL}/profiles`, profile);
  return res.data;
};

export const updateProfile = async (id, data) => {
  const res = await axios.put(`${API_URL}/profiles/${id}`, data);
  return res.data;
};

export const deleteProfile = async (id) => {
  const res = await axios.delete(`${API_URL}/profiles/${id}`);
  return res.data;
};

